export default "/images/framework/MyPuzzleCht.0d70cd98.svg?0d70cd98";